import { ButtonHTMLAttributes, ReactNode } from "react";
import styles from "./style.module.scss";
import classNames from "classnames";
interface BaseButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "default" | "selected";
  label: string | ReactNode;
  iconLeft?: ReactNode;
  iconRight?: ReactNode;
  className?: string;
  onClick: () => void;
  buttonRef?: React.RefObject<HTMLButtonElement>;
}

const BaseButton = ({
  variant = "default",
  label,
  iconLeft,
  iconRight,
  className,
  onClick,
  buttonRef,
  ...props
}: BaseButtonProps) => {
  return (
    <button
      ref={buttonRef}
      className={classNames(styles.baseButton, className, {
        [styles.baseButtonSelected]: variant === "selected",
      })}
      onClick={onClick}
      {...props}
    >
      {iconLeft && (
        <span className="iconLeft" data-testid="icon-left">
          {iconLeft}
        </span>
      )}
      <span data-testid="button-label">{label}</span>
      {iconRight && (
        <span className="iconRight" data-testid="icon-right">
          {iconRight}
        </span>
      )}
    </button>
  );
};

export default BaseButton;
